export default "__VITE_ASSET__83f2f872__"